import type { AuthStateDto } from '@easiibill/types';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryClient } from '@/lib/query';

export const AUTH_KEY = ['auth'] as const;

export function useAuthQuery() {
  return useQuery({
    queryKey: AUTH_KEY,
    queryFn: () => api<AuthStateDto | null>('/api/auth/me'),
    staleTime: 5 * 60_000,
    retry: 1,
  });
}

/** Auth state inside the signed-in app (the shell guarantees it is loaded). */
export function useAuth(): AuthStateDto {
  const { data } = useAuthQuery();
  if (!data) throw new Error('useAuth used outside an authenticated route');
  return data;
}

export function setAuthState(state: AuthStateDto | null): void {
  queryClient.setQueryData(AUTH_KEY, state);
}

export async function refreshAuth(): Promise<AuthStateDto | null> {
  return queryClient.fetchQuery({
    queryKey: AUTH_KEY,
    queryFn: () => api<AuthStateDto | null>('/api/auth/me'),
    staleTime: 0,
  });
}
